import loadable from '@loadable/component';

export const VRichTextEditor = loadable(() => import('./VRichTextEditor'));
